import React from "react";
import "./button.css";

const Button = ({
  name,
  primaryBtn,
  async,
  loading,
  width,
  spinnerRight,
  spinnerTop,
  height,
  handler,
  type,
  style
}) => {
  return primaryBtn ? (
    <button
      className="primary_btn shadow"
      style={{ width, height, ...style }}
      onClick={() => {
        handler ? handler() : null;
      }}
      type={type}
    >
      {name}
      {async && (
        <i
          className="fas fa-spinner fa-spin"
          style={{
            visibility: loading ? "visible" : "hidden",
            position: "absolute",
            top: spinnerTop || "11px",
            right: spinnerRight || '11px'
          }}
        />
      )}
    </button>
  ) : (
    <button
      className="calm_btn"
      onClick={handler}
      style={{
        width,
        height,
        ...style
      }}
    >
      {name}
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button-component.js